module.exports = __webpack_public_path__ + "static/media/A700.b012a8b8.png";